export default __webpack_public_path__ + "static/sample_cd_back-c5e96659ae3385dded246971ce70dd74.jpg";